import { Badge } from '@/shared/components/ui/badge';
import { MembershipStatus } from '@/types/api/membership';
import { membershipStatusBadge, membershipStatusLabel } from '../utils/membership-status';

export function MembershipStatusBadge({ status }: { status: MembershipStatus }) {
  return <Badge className={membershipStatusBadge(status)}>{membershipStatusLabel(status)}</Badge>;
}
